export const webServiceEndpoint = process.env.CHECKOUT_WEBSERVICE_ENDPOINT;
export const environment = process.env.CHECKOUT_ENVIRONMENT;
export const version = process.env.BUILD_NUMBER ?? "0.0.0";
